<script setup>
import { onMounted, ref, onUnmounted } from 'vue';
import uiRangeDatePickerPopup from './uiRangeDatePickerPopup';
import legoEventBus from '@/lego-component/utils/eventBus/eventBus';
import { EVENT_POPUP } from '@/components/constants/constants';

const emit = defineEmits(['save', 'close', 'inited', 'open']);

const props = defineProps({
  isPerformance: {
    type: Boolean,
    default: false,
    required: false
  },
  isMonitoringPerformance: {
    type: Boolean,
    default: false,
    required: false
  },
  refreshTime: {
    type: Boolean,
    required: true
  },
  index1Value: {
    type: String,
    required: false,
    default: '30m'
  },
  datePickerPositionUp: {
    type: Boolean,
    required: false
  },
  refreshInterval: {
    type: String,
    required: false,
    default: '1'
  },
  isDashboard: { type: Boolean, default: false },
  isLogDate: {
    type: Boolean,
    default: false
  }
});

const showPopupPicker = ref(false);
const justOpen = ref(false);
const refPopup = ref(null);

function handleSave(date) {
  emit('save', date);
}

function handleClose() {
  emit('close', showPopupPicker.value);
  showPopupPicker.value = false;
  legoEventBus.$emit(EVENT_POPUP.DATE_TIME_PICKER, showPopupPicker.value);
}

const handleOpen = () => {
  emit('open', showPopupPicker.value);
  justOpen.value = false;
  legoEventBus.$emit(EVENT_POPUP.DATE_TIME_PICKER, showPopupPicker.value);
};

function togglePopup() {
  legoEventBus.$emit('click-outside', true);
  showPopupPicker.value = !showPopupPicker.value;

  if (refPopup.value && showPopupPicker.value) {
    justOpen.value = true;
    refPopup.value.setDefalut(true);
  }
}

function hidePopup() {
  showPopupPicker.value = false;
}

onMounted(() => {
  emit('inited', refPopup.value);
  legoEventBus.$on('close_tooltips', () => hidePopup());
});

onUnmounted(() => {
  legoEventBus.$off('close_tooltips', () => hidePopup());
});
</script>

<template>
  <div class="range-datepicker-popup">
    <div class="date-time">
      <slot />

      <lego-icon-button
        iconType="df"
        icon="setting"
        class="ui-icon icon-setting"
        @click="togglePopup()"
        v-lego-tooltip="{
          value: $t('label.setInquiryTime'),
          moreAction: 'clickToHide',
          position: 'left'
        }"
      />
    </div>

    <uiRangeDatePickerPopup
      ref="refPopup"
      v-show="showPopupPicker"
      @close="handleClose"
      @save="handleSave"
      @opened="handleOpen()"
      :isDashboard="props.isDashboard"
      :intervalTime="props.refreshInterval"
      :isPerformance="props.isPerformance"
      :refreshTime="props.refreshTime"
      :isMonitoringPerformance="props.isMonitoringPerformance"
      :index1Value="props.index1Value"
      :datePickerPositionUp="datePickerPositionUp"
      :open-by-toggle="justOpen"
      :isLogDate="isLogDate"
    />
  </div>
</template>

<style scoped lang="scss">
.range-datepicker-popup {
  position: relative;

  .date-time {
    display: flex;
    align-items: center;
  }

  .ui-icon {
    width: 24px !important;
    height: 24px !important;
    background-color: transparent !important;
  }
  .ui-icon > i {
    width: 20px;
    height: 20px;
  }

  :deep {
    .ui-icon > i.opus-icon__setting {
      font-size: 23px !important;
    }
    .ui-icon > i.opus-icon__setting:hover {
      color: #22252a;
    }
  }
}
</style>
